/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Interview_Qbank_Seniority_MidInputs */

const en_interview_qbank_seniority_mid = /** @type {(inputs: Interview_Qbank_Seniority_MidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mid`)
};

const de_interview_qbank_seniority_mid = /** @type {(inputs: Interview_Qbank_Seniority_MidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mittel`)
};

const fr_interview_qbank_seniority_mid = /** @type {(inputs: Interview_Qbank_Seniority_MidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Intermédiaire`)
};

const es_interview_qbank_seniority_mid = /** @type {(inputs: Interview_Qbank_Seniority_MidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Intermedio`)
};

const it_interview_qbank_seniority_mid = /** @type {(inputs: Interview_Qbank_Seniority_MidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mid`)
};

const nl_interview_qbank_seniority_mid = /** @type {(inputs: Interview_Qbank_Seniority_MidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mid`)
};

const pl_interview_qbank_seniority_mid = /** @type {(inputs: Interview_Qbank_Seniority_MidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mid`)
};

const fi_interview_qbank_seniority_mid = /** @type {(inputs: Interview_Qbank_Seniority_MidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keskitaso`)
};

const da_interview_qbank_seniority_mid = /** @type {(inputs: Interview_Qbank_Seniority_MidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mellemniveau`)
};

const sv_interview_qbank_seniority_mid = /** @type {(inputs: Interview_Qbank_Seniority_MidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mellannivå`)
};

/**
* | output |
* | --- |
* | "Mid" |
*
* @param {Interview_Qbank_Seniority_MidInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const interview_qbank_seniority_mid = /** @type {((inputs?: Interview_Qbank_Seniority_MidInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Interview_Qbank_Seniority_MidInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_interview_qbank_seniority_mid(inputs)
	if (locale === "fr") return fr_interview_qbank_seniority_mid(inputs)
	if (locale === "es") return es_interview_qbank_seniority_mid(inputs)
	if (locale === "it") return it_interview_qbank_seniority_mid(inputs)
	if (locale === "nl") return nl_interview_qbank_seniority_mid(inputs)
	if (locale === "pl") return pl_interview_qbank_seniority_mid(inputs)
	if (locale === "fi") return fi_interview_qbank_seniority_mid(inputs)
	if (locale === "da") return da_interview_qbank_seniority_mid(inputs)
	if (locale === "sv") return sv_interview_qbank_seniority_mid(inputs)
	return en_interview_qbank_seniority_mid(inputs)
});